import { createContext, useContext, useEffect, useState } from "react";
import { getFromStorage, setToStorage } from "../assets/functions";
import { useQuery } from "@tanstack/react-query";
import { getSettings } from "src/api";


const ProtectedRoutesContext = createContext({
    user: true,
    setUser: () => { },
    setToken: () => { },
    token: true,
    unitId: "",
    conversionRates: {}
});

export const useProtectedRoutesContext = () => useContext(ProtectedRoutesContext);

const ProtectedRoutesProvider = ({ children }) => {
    const [user, setUser] = useState(getFromStorage("user") ?? null);
    const [token, setToken] = useState(getFromStorage("token") ?? null);

    useEffect(() => {
        setToStorage("user", user);
    }, [user]);
    useEffect(() => {
        setToStorage("token", token);
    }, [token]);

    const { data: settings } = useQuery({
        queryKey: ["settings"],
        queryFn: () => getSettings(),
        suspense: true
    });

    const unitId = settings?.unitId
    const conversionRates = settings?.conversionRates

    return <ProtectedRoutesContext.Provider value={{ user, setUser, token, setToken, unitId, conversionRates }}>{children}</ProtectedRoutesContext.Provider>;
};

export default ProtectedRoutesProvider;
